export const CREATE_PACKAGE = 'createPackage';
export const UPDATE_PACKAGE = 'updatePackage';
export const PACKAGE_FEATURES = 'packageFeatures';
export const COMPARE_PACKAGE = 'comparePackage';
